<template>
	<div class="review-progress">
		<table id="psjd-datatable" class="table table-hover table-bordered table-centered table-proApp" v-if="curShow == 0">
			<thead>
				<tr>
					<th class="text-center">专家名称</th>
					<th class="text-center">手机/电话</th>
					<th class="text-center">所属评审组</th>
					<th class="text-center">应评数量</th>
					<th class="text-center">已评数量</th>
					<th class="text-center">剩余数量</th>
					<th class="text-center">是否提交评分</th>
					<th class="text-center">操作</th>
					<!-- <th class="text-center">建议立项数</th>
					<th class="text-center">不建议立项数</th> -->
				</tr>
			</thead>

			<tbody v-if="reviewProgressList.length">
				<tr v-for="(item, index) in reviewProgressList" :key="item.id">
					<td class="text-center">{{ item.name }}</td>
					<td class="text-center">{{ item.phone }}</td>
					<td class="text-center">{{ item.groupName }}</td>
					<td class="text-center">{{ item.toReviewDeclareNumber }}</td>
					<td class="text-center">{{ item.hasReviewDeclareNumber }}</td>
					<td class="text-center">{{ item.residueDeclareNumber }}</td>
					<td class="text-center">{{ item.isSubmit == 1 ? '已提交' : '未提交' }}</td>
					<td class="text-center"><span class="btn" @click="viewDetail(item.userId, item.name)">查看详情</span>
					<el-button type="text" v-if="item.isSubmit==1" @click="cancleCommitScore(item.userId)">取消提交评分</el-button>
					</td>


					<!-- <td class="text-center">{{item.proposalProjectNumber}}</td>
					<td class="text-center">{{item.notProposalProjectNumber}}</td> -->
				</tr>
			</tbody>
		</table>

		<div class="expert_review_progress_detail_wrap" v-else>
			<div class="title">
				<div class="left">专家名字：{{ curUserName }}</div>
				<div class="right"><el-button type="primary" @click="curShow = 0">返回</el-button></div>
			</div>
			<ul class="review_stat">
				<li class="item" v-for="(item, index) in topicStat" :key="index">
					<div class="num">{{ item.number }}</div>
					<div class="title">{{ item.name }}</div>
				</li>
			</ul>
			<div class="table_wrap">
				<el-table id="table" :header-cell-style="tableStyle" :data="topicList" border style="width: 100%">
					<el-table-column prop="declareName" label="课题名称"></el-table-column>
					<el-table-column prop="learningTypeName" label="学段"></el-table-column>
					<el-table-column prop="disciplineName" label="学科"></el-table-column>
					<el-table-column prop="projectTypeName" label="类别"></el-table-column>
					<el-table-column prop="oneEmceeName" label="负责人"></el-table-column>
					<el-table-column prop="score" label="分数"></el-table-column>
					<el-table-column prop="typeName" label="评审结果"></el-table-column>
					<el-table-column prop="note" label="评语">
						<template v-slot="scope">
							<span class="view_remark" @click="viewRemark(scope.row.note)">查看</span>
						</template>
					</el-table-column>
				</el-table>
				<el-button type="primary" style="margin-top: 10px;" @click="exportExcel">导出Excel</el-button>
			</div>
		</div>

		<el-dialog title="评语" :visible.sync="remarkDialogVisible" width="30%" :before-close="handleClose">
			<span>{{ curRemark }}</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="remarkDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="remarkDialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { getReviewProgress, getExpertReviewDetail,cancleCommitScore } from '@/api/after/topicManage.js';
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
	data() {
		return {
			reviewProgressList: [], //评审进度列表
			progressTotal: 0,
			progressParams: {
				id: 0,
				name: '',
				pageNumber: 1,
				pageSize: 100,
				regionId: 0
			},
			topicList: [],
			topicStat: [],
			tableStyle: {
				textAlign: 'center',
				backgroundColor: '#7e9be2',
				color: '#fff'
			},
			curShow: 0, //0：显示专家表，1：显示专家课题表
			curUserName: '', //当前专家名称
			curRemark: '', //当前评语
			remarkDialogVisible: false
		};
	},
	created() {
		this.getReviewProgress();
	},
	methods: {
		// 获取评审进度
		async getReviewProgress() {
			this.progressParams.id = this.$route.query.reviewId;
			const res = await getReviewProgress(this.progressParams);
			if (res.code == 200) {
				console.log('评审进度', res);
				this.reviewProgressList = res.data.records;
				this.progressTotal = res.data.progressTotal;
			} else {
				this.$message.error(res.data);
			}
		},
		// 查看当前专家评审进度详情
		viewDetail(userId, userName) {
			this.curShow = 1;
			this.curUserName = userName;
			this.getExpertReviewDetail({ expertId: userId, reviewId: this.$route.query.reviewId });
		},
		async getExpertReviewDetail(params) {
			const res = await getExpertReviewDetail(params);
			if (res.code == 200) {
				console.log('获取专家课题列详情', res);
				this.topicList = res.data.infoList;
				this.topicStat = res.data.countList;
				console.log(this.topicList, this.topicStat);
			} else {
				this.$message.error(res.data);
			}
		},
		// 查看评语
		viewRemark(remark) {
			if (remark) {
			} else {
				this.$message.warning('当前课题还没有添加评语！');
			}
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		},
		// 导出Excel表格
		exportExcel() {
			var xlsxParam = { raw: true };
			var wb = XLSX.utils.table_to_book(
			  document.querySelector("#table"),
			  xlsxParam
			);
			var wbout = XLSX.write(wb, {
			  bookType: "xlsx",
			  bookSST: true,
			  type: "array",
			});
			try {
			  FileSaver.saveAs(
			    new Blob([wbout], { type: "application/octet-stream" }),
			    `专家${this.curUserName}审核详情.xlsx`
			  );
			} catch (e) {
			  if (typeof console !== "undefined") {
			    console.log(e, wbout);
			  }
			}
			return wbout;
		},
				//取消评分
		cancleCommitScore(userId){
			// console.log(userId);
			let settingId = this.$route.query.reviewId;

			cancleCommitScore(userId, settingId).then((res)=>{
				if(200 == res.code){
						this.reviewProgressList.forEach((item, index)=>{
							if(item.userId == userId){
									this.reviewProgressList[index].isSubmit = 0;
							}
						})
						this.$message.success('取消成功');
				}else{
						this.$message.error('取消失败');
				}
				
			}).catch((err)=>{
				this.$message.error('取消失败');
			})
		},
	}
};
</script>

<style scoped lang="scss">
.btn,
.view_remark {
	cursor: pointer;
	color: #00b0f0;
}
.expert_review_progress_detail_wrap {
	.title {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 20px;
		.left {
		}
		.right {
		}
	}
	.review_stat {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		.item {
			display: flex;
			flex-direction: column;
			align-items: center;
			align-content: center;
			margin-right: 20px;
			.num {
				margin-bottom: 10px;
			}
			.title {
			}
		}
	}
	.table_wrap {
	}
}
</style>
